import React, { useRef, useState, useEffect, useMemo, useCallback } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { trackGA } from "../utils/ga";
import "react-circular-progressbar/dist/styles.css";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";
import { connect, useSelector } from "react-redux";
import VideoPlayer from "../components/VideoPlayer";
import { Text, TextInput, TouchableOpacity } from "react-native";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoMdVolumeOff, IoMdVolumeHigh } from "react-icons/io";
import {
  FaPause,
  FaPlay,
  FaArrowRight,
  FaStopwatch,
  FaBug,
  FaSearch,
  FaSyncAlt,
  FaTrashAlt,
  FaEdit,
  FaVideo,
  FaCheckCircle,
  FaExclamationCircle,
  FaCheck,
  FaPlus,
  FaTimes,
  FaArrowLeft,
  FaAngleDown,
  FaAngleUp,
  FaLink,
} from "react-icons/fa";
import Duration from "../components/VideoPlayer(new)/Duration";
import {
  fetchMatchStringById,
  getAllReviewerFeedbackStrings,
  matchReviewerIds,
  reviewRowsFor,
  runTechQC,
  saveReviewerFeedback,
} from "../config/mainRequest";
import { useHistory, useParams } from "react-router-dom";
import { pushCompletedTechQCString } from "../config/mainRequest";
import { createCheckpoint } from "../persistence/managers/CheckpointManager";
import { EVENT_MAP } from "../constant/positionList";
import Logo from "../assets/Logo";
import toast from "react-hot-toast";
import {
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  Modal,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import { ArrowBack, InfoOutlined, DarkModeOutlined, LightModeOutlined } from "@mui/icons-material";
import { useThemeMode } from "../theme/ThemeContext";
import { v4 as uuidv4 } from "uuid";
import { FlatList, View } from "react-native-web";
import { AutoSizer, CellMeasurer, List, CellMeasurerCache } from "react-virtualized";
import { useQuery } from "react-query";
import { useAbly } from "ably/react";

// Confirmation Modal Component
const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  type = "default",
  isDarkMode = false,
}) => {
  const getColors = () => {
    switch (type) {
      case "delete":
        return { bg: "#DA1414", hover: "#B91010" };
      case "update":
        return { bg: "#FF5A1F", hover: "#E54D18" };
      default:
        return { bg: "#007D48", hover: "#006838" };
    }
  };

  const colors = getColors();
  const modalBg = isDarkMode ? "#000" : "#fff";
  const modalText = isDarkMode ? "#fff" : "#111827";
  const cancelBg = isDarkMode ? "#000" : "#fff";
  const cancelHoverBg = isDarkMode ? "#111827" : "#F3F4F6";
  const cancelBorder = isDarkMode ? "#4B5563" : "#D1D5DB";

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal"
      aria-describedby="confirmation-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: modalBg,
          color: modalText,
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Stack spacing={3}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" component="h2" fontWeight={600} sx={{ color: modalText }}>
              {title}
            </Typography>
            <IconButton onClick={onClose} size="small" sx={{ color: isDarkMode ? "#E5E7EB" : "#666" }}>
              <FaTimes />
            </IconButton>
          </Stack>

          <Typography sx={{ color: modalText }}>{message}</Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              onClick={onClose}
              sx={{
                textTransform: "none",
                color: `${modalText} !important`,
                bgcolor: cancelBg,
                border: `1px solid ${cancelBorder}`,
                "&:hover": {
                  bgcolor: cancelHoverBg,
                  borderColor: isDarkMode ? "#6B7280" : "#9CA3AF",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              sx={{
                textTransform: "none",
                bgcolor: colors.bg,
                "&:hover": {
                  bgcolor: colors.hover,
                },
              }}
            >
              Confirm
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
const increaseTimestampByOneSecond = (timeString) => {
  if (!timeString) return timeString;

  const [hh, mm, ss] = timeString.split(":").map(Number);
  let totalSeconds = hh * 3600 + mm * 60 + ss + 1; // +1 second

  const newHH = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const newMM = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const newSS = String(totalSeconds % 60).padStart(2, "0");

  return `${newHH}:${newMM}:${newSS}`;
};

const TechQCMS = (props) => {
  const { UpdateVideoTime, SetVideoControl, videoUrl, all_matches } = props;
  const { matchId } = useParams();
  const matchDetails = (props.all_matches || []).find(
    (match) => String(match.id) === String(matchId)
  );
  const { analystId, token, role } = useSelector((state) => ({
    analystId: state.auth.analyst_id,
    token: state.auth.token,
    role: state.auth.accountRole,
  }));

  // Google Analytics helper — shared context on every event.
  const track = useCallback(
    (action, extra = {}) =>
      trackGA(action, {
        screen: "tech_qc_ms",
        match_id: matchId,
        user_id: analystId,
        role,
        ...extra,
      }),
    [matchId, analystId, role]
  );

  const ably = useAbly();
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [showControls, setShowControl] = useState(false);
  const [isMute, setIsMute] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const playerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [initialEventDetails, setInitialEventDetails] = useState({});
  const [hasInitialized, setHasInitialized] = useState(false);
  const history = useHistory();
  const [isRunningQC, setIsRunningQC] = useState(false);
  const [IsInitialQC, setIsInitialQC] = useState(false);
  // Every reviewer's feedback is shown; reviewerId (the first reviewer) only
  // receives updates for strings no reviewer has commented on.
  const reviewerIds = matchReviewerIds(matchDetails, analystId);
  const reviewerId = reviewerIds[0];
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchStringValue, setSearchStringValue] = useState("");
  const [currentErrorGlobalIndex, setCurrentErrorGlobalIndex] = useState(-1);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [skipScrollToIndex, setSkipScrollToIndex] = useState(false);
  const [qcResultModal, setQcResultModal] = useState(null);
  const [urlInput, setUrlInput] = useState("");
  const [showUrlInput, setShowUrlInput] = useState(false);

  const { mode: themeMode, toggleMode } = useThemeMode();

  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("theme-dark"),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("theme-dark"));
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  // Modal states
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    value: "",
  });
  const [updateModal, setUpdateModal] = useState({
    open: false,
    id: null,
    oldValue: "",
    newValue: {},
  });

  const { data: reviewStrings, refetch: refetchReviewerStrings } = useQuery({
    queryKey: ["getReviewerStrings", matchId, reviewerIds.join(",")],
    queryFn: () => getAllReviewerFeedbackStrings({ matchId, token, reviewerIds }),
    enabled: Boolean(matchDetails) && reviewerIds.length > 0,
  });

  // Process review strings to create a map of string -> review data
  const reviewStringMap = React.useMemo(() => {
    if (!reviewStrings?.string_details) return new Map();

    const map = new Map();
    Object.entries(reviewStrings.string_details).forEach(([key, value]) => {
      map.set(key.trim(), value);
    });
    return map;
  }, [reviewStrings]);

  const handleLogout = () => {
    console.log("Logout clicked");
    // Logout logic here
  };

  const isYoutubeUrl = () => {
    if (videoUrl || matchDetails?.youtube_videos?.[0]?.url) {
      const hostname = new URL(videoUrl || matchDetails?.youtube_videos?.[0]?.url)
        .hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };

  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
    track("tech_qc_ms_video_seek", { seek_to: parseFloat(e.target.value) });
  };

  const full = () => {
    track("tech_qc_ms_fullscreen");
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  const handleMute = () => {
    track("tech_qc_ms_video_mute", { muted: !isMute });
    setIsMute(!isMute);
  };

  const jumpManually = (str) => {
    const jumpInputList = str?.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    setPlaying(true);
    setJumpTo("");
    track("tech_qc_ms_jump_to_time", { time: str });
  };

  // Google Analytics – screen view on mount.
  useEffect(() => {
    track("tech_qc_ms_screen_view");
  }, [track]);

  // Track playback-speed changes (skip the initial mount value).
  const _speedTracked = useRef(false);
  useEffect(() => {
    if (!_speedTracked.current) { _speedTracked.current = true; return; }
    track("tech_qc_ms_video_speed", { speed });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speed]);

  const [matchString, setMatchString] = useState([]);
  const [fetchedQcData, setFetcheddQcData] = useState();
  const [transformedStrings, setTransformedStrings] = useState();
  const listRef = useRef(null);
  const [currentErrorIndex, setCurrentErrorIndex] = useState(0);
  const [searchMatchIndexes, setSearchMatchIndexes] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);
  const transformMatchStrings = (qcData) => {
    if (!qcData) return [];

    return qcData.reduce((acc, item) => {
      if (!Array.isArray(item.examples)) return acc;

      const { error_type, message, examples } = item;

      const transformed = examples.map((example) => ({
        id: uuidv4(),
        value: example,
        type: error_type.toLowerCase(),
        message,
        ignored: false,
      }));

      return acc.concat(transformed);
    }, []);
  };

  useEffect(() => {
    const getMatchString = async () => {
      try {
        setIsLoading(true);
        const result = await fetchMatchStringById(matchId, analystId, token);
        setMatchString(
          result?.temp_string
            ? result.temp_string.split(",").map((str) => str.trim()).filter(Boolean)
            : []
        );
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Failed to fetch match string", error);
      }
    };

    if (matchId && analystId && token) {
      getMatchString();
    }
  }, [matchId, analystId, token]);

  useEffect(() => {
    if (!matchString || matchString.length === 0) return;
    const stringArray = matchString
      .map((item) => (typeof item === "string" ? item : item?.value))
      .filter(Boolean);

    const runTechQCString = async () => {
      try {
        setIsInitialQC(true);
        track("run_onload_qc_analysis", { trigger: "initial_load", string_event_count: stringArray.length });
        const qcResult = await runTechQC(stringArray, token, matchId);
        setFetcheddQcData(qcResult?.qc_results);
        setIsInitialQC(false);
      } catch (error) {
        setIsInitialQC(false);
        console.error("Failed to fetch match string", error);
      }
    };

    if (matchString && token) {
      runTechQCString();
    }
  }, [matchId, matchString, token]);

  // helper moved outside effect so it can be reused by handlers
  const mergeMatchStringsWithErrors = (
    baseStrings,
    qcData,
    existingTransformed = null
  ) => {
    const errors = transformMatchStrings(qcData);

    const errorMap = new Map();
    const parseErrorValue = (value) => {
      const strings = [];

      let cleanValue = value;
      if (value.includes(":")) {
        const colonIndex = value.indexOf(":");
        if (colonIndex < 50 && value[colonIndex + 1] === " ") {
          cleanValue = value.substring(colonIndex + 1).trim();
        }
      }

      // arrow notation
      if (cleanValue.includes("->")) {
        const parts = cleanValue.split("->").map((p) => p.trim());
        strings.push(...parts.filter(Boolean));
      } else if (cleanValue.includes(",")) {
        //  csv values
        const parts = cleanValue.split(",").map((p) => p.trim());
        strings.push(...parts.filter(Boolean));
      } else {
        // Single value
        strings.push(cleanValue.trim());
      }

      return strings.filter(Boolean);
    };

    errors.forEach((item) => {
      if (item.value) {
        const parts = parseErrorValue(item.value);

        parts.forEach((part) => {
          const existing = errorMap.get(part.trim());

          if (existing) {
            existing.push(item);
          } else {
            errorMap.set(part.trim(), [item]);
          }
        });
      }
    });

    const normalize = (v) => (typeof v === "string" ? v.trim() : v?.value?.trim());

    // If we have existing transformedStrings (manual additions), store them
    if (existingTransformed && existingTransformed?.length > 0) {
      return existingTransformed.map((str) => {
        const value = normalize(str);
        const errorArray = errorMap.get(value);
        const reviewData = reviewStringMap.get(value);

        // Determine type and message based on QC
        let finalType = "noIssue";
        let finalMessage = null;

        if (errorArray) {
          finalType = errorArray.some((err) => err.type === "warning")
            ? "warning"
            : "error";
          finalMessage = errorArray.map((err) => err.message).join(" | ");
        }

        // Review errors override QC result
        if (reviewData?.string_status === 0) {
          finalType = "review_error";
          finalMessage = reviewData?.comments || "Pending review feedback";
        }

        const isIgnored =
          reviewData?.string_status === 3 || reviewData?.string_status === 2;
        // Only override to "ignored" when there are NO active QC errors
        if (isIgnored && !errorArray) {
          finalType = "ignored";
          finalMessage = str.message || reviewData?.comments || finalMessage;
        }

        return {
          ...str,
          id: uuidv4(),
          issues: errorArray || [],
          type: finalType,
          message: finalMessage,
          ignored: isIgnored,
          reviewStatus: reviewData?.string_status,
          reviewComments: reviewData?.comments,
          reviewEntries: reviewData?.byReviewer ?? [],
        };
      });
    }

    // Initial load or no existing transformed strings - use baseStrings
    return baseStrings.map((str) => {
      const value = str?.trim();
      const errorArray = errorMap.get(value);
      const reviewData = reviewStringMap.get(value);

      // Determine type based on errors and review status
      let finalType = "noIssue";
      let finalMessage = null;

      if (errorArray) {
        finalType = errorArray.some((err) => err.type === "warning")
          ? "warning"
          : "error";
        finalMessage = errorArray.map((err) => err.message).join(" | ");
      }

      // If review status is 0 (Pending), mark as review_error
      if (reviewData?.string_status === 0) {
        finalType = "review_error";
        finalMessage = reviewData?.comments || "Pending review feedback";
      }

      // id status is 3 then mark it as ignore if status is 2 from reviewer side and comment is present consider it as ignored as for error status is 1
      const isIgnored =
        reviewData?.string_status === 3 ||
        reviewData?.string_status === 2;

      // Only override to "ignored" when there are NO active QC errors
      if (isIgnored && !(errorArray?.length > 0)) {
        finalType = "ignored";
      }

      return {
        value: value,
        id: uuidv4(),
        issues: errorArray || [],
        type: finalType,
        message: finalMessage,
        ignored: isIgnored,
        reviewStatus: reviewData?.string_status,
        reviewComments: reviewData?.comments,
        reviewEntries: reviewData?.byReviewer ?? [],
      };
    });
  };

  useEffect(() => {
    if (matchString?.length > 0 && fetchedQcData?.length >= 0) {
      setTransformedStrings((transformedStrings) => {
        const base =
          transformedStrings?.length > 0
            ? transformedStrings.map((s) => s.value)
            : matchString;

        const merged = mergeMatchStringsWithErrors(
          base,
          fetchedQcData,
          transformedStrings
        );
        return merged;
      });
    }
  }, [matchString, fetchedQcData, reviewStringMap]);

  const updateTag = async (id, newValue) => {
    const oldItem = transformedStrings?.find((s) => s.id === id);

    if (!oldItem) {
      console.warn("Item not found for update");
      return;
    }

    const valueChanged = oldItem.value !== newValue.value;

    // If type is "fixed" and value hasn't changed (e.g. from Mark as Fixed button), just update state
    if (newValue.type === "fixed" && !valueChanged) {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );
      setTransformedStrings(updatedArray);
      return;
    }

    // If item is a warning and value hasn't changed, just update state
    if (oldItem.type === "warning" && !valueChanged) {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );

      setTransformedStrings(updatedArray);

      return;
    }

    // If value hasn't changed at all (blur without editing), no-op
    if (!valueChanged) {
      return;
    }

    // Value was changed — open confirmation modal
    setUpdateModal({
      open: true,
      id,
      oldValue: oldItem.value,
      newValue: { ...oldItem, ...newValue },
    });
  };

  const confirmUpdate = async () => {
    const { id, oldValue, newValue } = updateModal;
    track("tech_qc_confirm_update", {
      previous_event_string: oldValue,
      changed_event_string: newValue?.value ?? "",
    });
    const oldItem = transformedStrings?.find((s) => s.id === id);

    if (
      oldItem.type === "error" ||
      oldItem.type === "warning" ||
      oldItem.type === "review_error"
    ) {
      newValue.type = "fixed";
      newValue.message = "Issue resolved";
    }

    const updatedArray = transformedStrings.map((item) =>
      item.id === id ? { ...item, ...newValue, id: item.id } : item
    );

    // UPDATE STATE
    setTransformedStrings(updatedArray);

    setTimeout(() => {
      const index = updatedArray.findIndex((s) => s.id === id);
      for (let i = index; i <= updatedArray.length - 1; i++) {
        cache.current.clear(i, 0);
      }

      if (listRef.current) {
        listRef.current.scrollToPosition(scrollPosition);
        // listRef.current.recomputeRowHeights(index);
      }
    }, 0);

    // API update
    const stringArray = updatedArray
      .map((item) => item.value?.trim())
      .filter((v) => v && v.length > 0)
      .join(",");

    const _editPushResult = await pushCompletedTechQCString(matchId, analystId, token, stringArray, 1);
    if (_editPushResult?.success) {
      createCheckpoint({
        matchId:       String(matchId),
        analystId:     String(analystId),
        currentString: stringArray,
        triggerType:   "techqc-edit",
        skipFirestore: true,  // server already has this string — no Firestore backup needed
      }).catch(() => {});
    }

    ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
      matchId,
      updatedAt: Date.now(),
    });

    // REVIEW LOGIC
    if (oldItem.type === "review_error") {
      try {
        // Each reviewer who flagged the string gets their own update.
        await Promise.all(
          reviewRowsFor(oldItem, reviewerId).map((row) =>
            saveReviewerFeedback({
              token,
              body: {
                match_id: Number(matchId),
                reviewer_id: row.reviewer_id,
                string_details: [
                  {
                    string: oldItem.value,
                    string_status: row.string_status,
                    comments: row.comments,
                    delete: true,
                  },
                  {
                    string: newValue.value,
                    string_status: 1,
                    comments: row.comments,
                  },
                ],
              },
            })
          )
        );

        toast.success("Feedback saved!");
      } catch (err) {
        console.error("Failed to save feedback:", err);
        toast.error("Failed to save feedback.");

        // rollback
        setTransformedStrings((prevStrings) =>
          prevStrings.map((item) => (item.id === id ? oldItem : item))
        );
      }
    }

    setUpdateModal({ open: false, id: null, oldValue: "", newValue: {} });
  };

  const addTag = (afterId) => {
    track("tech_qc_add_string");
    setCurrentErrorGlobalIndex(null);
    setSkipScrollToIndex(true);

    setTransformedStrings((prevStrings) => {
      const index = prevStrings.findIndex((item) => item.id === afterId);
      if (index === -1) return prevStrings;

      const newItem = {
        id: uuidv4(),
        value: " ",
        type: "noIssue",
        message: null,
        ignored: false,
      };

      setTimeout(() => {
        const startIndex = Math.max(0, index);
        for (let i = startIndex; i <= updated.length - 1; i++) {
          cache.current.clear(i, 0);
        }

        if (listRef.current) {
          listRef.current.scrollToPosition(scrollPosition);
          // listRef.current.recomputeRowHeights(index);
        }
      }, 0);

      const updated = [...prevStrings];
      updated.splice(index + 1, 0, newItem);
      return updated;
    });
  };

  useEffect(() => {
    if (skipScrollToIndex) {
      setSkipScrollToIndex(false);
    }
  }, [transformedStrings]);

  const runTechQCManually = async () => {
    const stringArray = transformedStrings
      .map((item) => (typeof item === "string" ? item : item?.value)?.trim())
      .filter((v) => v && v.length > 0);

    try {
      setIsRunningQC(true);
      track("run_tech_qc_manually", { trigger: "manual", string_event_count: stringArray.length });
      const qcResult = await runTechQC(stringArray, token, matchId);
      setFetcheddQcData(qcResult.qc_results);
      const base = transformedStrings?.length > 0 ? transformedStrings.map((s) => s.value) : stringArray;
      const merged = mergeMatchStringsWithErrors(base, qcResult.qc_results, transformedStrings);
      setTransformedStrings(merged);

      if (listRef.current) {
        cache.current.clearAll();
        // listRef.current.recomputeRowHeights();
        listRef.current.scrollToPosition(scrollPosition);
      }

      setQcResultModal({
        errorCount: merged.filter((i) => i.type === "error").length,
        reviewErrorCount: merged.filter((i) => i.type === "review_error").length,
        warningCount: merged.filter((i) => i.type === "warning").length,
        noErrorsCount: merged.filter((i) => i.type === "noIssue").length,
        total: merged.length,
      });
      setIsRunningQC(false);
    } catch (error) {
      console.error("Failed to fetch match string", error);
      toast.error("Failed to Run QC");
      setIsRunningQC(false);
    }
  };

  const handleSubmitFinalQC = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const stringArray = transformedStrings
      .map((item) => (typeof item === "string" ? item : item?.value)?.trim())
      .filter((v) => v && v.length > 0);

    try {
      track("tech_qc_submit_final", { trigger: "final_submit", string_event_count: stringArray.length });
      const qcResult = await runTechQC(stringArray, token, matchId);
      const latestQC = qcResult?.qc_results || [];
      // update state and merge errors so new strings reflect status
      setFetcheddQcData(qcResult?.qc_results);
      setTransformedStrings((prev) => {
        const base = prev?.length > 0 ? prev.map((s) => s.value) : stringArray;
        return mergeMatchStringsWithErrors(base, qcResult?.qc_results, prev);
      });
      cache.current.clearAll();
      if (listRef.current) {
        listRef.current.scrollToPosition(scrollPosition);
        // listRef.current.recomputeRowHeights(index);
      }
      const qcIssues = latestQC.flatMap((item) =>
        item.examples.map((ex) => ({
          str: ex,
          type: item.error_type.toLowerCase(),
        }))
      );

      let actualErrors = 0;
      let actualWarnings = 0;

      stringArray.forEach((str) => {
        const issuesForStr = qcIssues.filter((i) => i.str === str);
        const hasError = issuesForStr.some((i) => i.type === "error");
        const hasWarning = issuesForStr.some((i) => i.type === "warning");
        const uiItem = transformedStrings.find((item) => item.value === str);
        const isIgnored =
          uiItem?.type === "ignored" || uiItem?.reviewStatus === 3;

        if (hasError && isIgnored) return;
        if (hasError && hasWarning) return;
        if (hasWarning && isIgnored) return;
        if (hasWarning) actualWarnings++;
        if (hasError) actualErrors++;
      });

      if (actualErrors > 0 || actualWarnings > 0) {
        setFetcheddQcData(latestQC);

        // cache.current.clearAll();
        if (listRef.current) {
          listRef.current.recomputeRowHeights();
        }

        toast.error("QC Failed! Fix all errors/warnings before submitting.");
        setIsSubmitting(false);
        return;
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to run QC before final submission.");
      setIsSubmitting(false);
      return;
    }

    const updatedArray = [...stringArray];
    let lastStr = updatedArray[updatedArray.length - 1];
    let parts = lastStr.split("-");

    if (parts[6]) {
      parts[6] = increaseTimestampByOneSecond(parts[6]);
      updatedArray[updatedArray.length - 1] = parts.join("-");
    }

    const finalMatchString = updatedArray.join(",");

    const result = await pushCompletedTechQCString(
      matchId,
      analystId,
      token,
      finalMatchString
    );

    if (result.success) {
      toast.success("Match String Saved Successfully");
      createCheckpoint({
        matchId:       String(matchId),
        analystId:     String(analystId),
        currentString: finalMatchString,
        triggerType:   "techqc-submit",
        skipFirestore: true,  // server already has this string — no Firestore backup needed
      }).catch(() => {});

      ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
        matchId,
        updatedAt: Date.now(),
      });

      setTimeout(() => {
        history.push(`/videoplayer?match_id=${matchId}`, {
          TechQCSubmit: true,
        });
      }, 800);
    } else {
      toast.error("Failed to push match string");
    }

    setIsSubmitting(false);
  };

  const deleteStringByIndex = async (id) => {
    setCurrentErrorGlobalIndex(null);
    setSkipScrollToIndex(true);
    const item = transformedStrings?.find((s) => s.id === id);

    // Open modal instead of directly deleting
    setDeleteModal({
      open: true,
      id,
      value: item?.value || "",
    });
  };

  const confirmDelete = async () => {
    const { id } = deleteModal;
    track("tech_qc_delete_string", { deleted_string: deleteModal.value });

    const item = transformedStrings?.find((s) => s.id === id);
    const deleteIndex = transformedStrings.findIndex((s) => s.id === id);

    // Handle review error logic BEFORE updating the strings
    if (item?.type === "review_error") {
      await Promise.all(
        reviewRowsFor(item, reviewerId, { all: true }).map((row) =>
          saveReviewerFeedback({
            token,
            body: {
              match_id: Number(matchId),
              reviewer_id: row.reviewer_id,
              string_details: [
                {
                  string: item.value,
                  string_status: row.string_status,
                  comments: row.comments,
                  delete: true,
                },
              ],
            },
          })
        )
      );
    }

    setTimeout(() => {
      if (deleteIndex !== -1) {
        const startIndex = Math.max(0, deleteIndex);

        for (let i = startIndex; i <= updatedArray.length - 1; i++) {
          cache.current.clear(i, 0);
        }

        if (listRef.current) {
          listRef.current.scrollToPosition(scrollPosition);
          // listRef.current.recomputeRowHeights(index);
        }
      }
    }, 0);
    const updatedArray = transformedStrings.filter((s) => s.id !== id);
    setTransformedStrings(updatedArray);

    const stringArray = updatedArray
      .map((item) => item.value?.trim())
      .filter((v) => v && v.length > 0)
      .join(",");

    const _deletePushResult = await pushCompletedTechQCString(matchId, analystId, token, stringArray, 1);
    if (_deletePushResult?.success) {
      createCheckpoint({
        matchId:       String(matchId),
        analystId:     String(analystId),
        currentString: stringArray,
        triggerType:   "techqc-delete",
        skipFirestore: true,  // server already has this string — no Firestore backup needed
      }).catch(() => {});
    }
    toast.success("String deleted successfully");
    ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
      matchId,
      updatedAt: Date.now(),
    });
    setDeleteModal({ open: false, id: null, value: "" });
  };

  const warningCount = transformedStrings?.filter(
    (item) => item.type === "warning"
  ).length;

  const errorCount = transformedStrings?.filter(
    (item) => item.type === "error"
  ).length;

  const noErrorsCount = transformedStrings?.filter(
    (item) => item.type === "noIssue"
  ).length;

  const reviewErrorCount = transformedStrings?.filter(
    (item) => item.type === "review_error"
  ).length;

  useEffect(() => {
    if (
      warningCount >= 0 &&
      errorCount >= 0 &&
      reviewErrorCount >= 0 &&
      noErrorsCount >= 0 &&
      !hasInitialized
    ) {
      const details = {
        warning: warningCount,
        error: errorCount,
        reviewError: reviewErrorCount,
        noIssue: noErrorsCount,
        total: transformedStrings.length,
      };
      setInitialEventDetails(details);
      setHasInitialized(true);
    }
  }, [
    errorCount,
    reviewErrorCount,
    noErrorsCount,
    warningCount,
    hasInitialized,
    transformedStrings?.length,
  ]);

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const details = all_matches?.find((m) => {
    return m.id.toString() === matchId;
  });

  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 180,
    })
  );

  // useEffect(() => {
  //   cache.current.clearAll();
  //   if (listRef.current) {
  //     listRef.current.recomputeRowHeights();
  //   }
  // }, [searchStringValue, activeFilter ,transformedStrings]);

  // useEffect(() => {
  //   if (listRef.current) {
  //     listRef.current.forceUpdateGrid();
  //   }
  // }, [searchStringValue, activeFilter, transformedStrings]);

  // const scrollToErrorIndex = (index, filteredData) => {
  //   if (!listRef.current) return;

  //   listRef.current.scrollToRow(index);
  // };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!playerRef.current) return;

      switch (e.key) {
        case " ":
          e.preventDefault();
          track("tech_qc_ms_video_playpause", { playing: !props.videoControl, source: "keyboard" });
          props.SetVideoControl(!props.videoControl);
          break;

        case "ArrowRight":
          playerRef.current.seekTo(props.videoTime + 5);
          break;

        case "ArrowLeft":
          playerRef.current.seekTo(props.videoTime - 5);
          break;

        case "m":
        case "M":
          setIsMute((prev) => !prev);
          break;

        // case "f":
        // case "F":
        //   if (screenfull.isEnabled) {
        //     screenfull.toggle(findDOMNode(playerRef.current));
        //   }
        //   break;

        case "P":
          goToPrevError();
          break;

        case "N":
          goToNextError();
          break;

        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [props.videoControl, props.videoTime, playerRef]);

  useEffect(() => {
    cache.current.clearAll();

    if (listRef.current) {
      listRef.current.recomputeRowHeights();
    }
  }, [activeFilter]);

  const visibleErrorGlobalIndexes = useMemo(() => {
    if (!transformedStrings || transformedStrings.length === 0) return [];

    const search = (searchStringValue || "").trim().toLowerCase();

    return transformedStrings.reduce((acc, item, idx) => {
      // Must be error, warning or review_error
      const isErrorType =
        item.type === "error" ||
        item.type === "warning" ||
        item.type === "review_error";

      if (!isErrorType) return acc;

      // Apply filter
      if (activeFilter !== "all" && item.type !== activeFilter) return acc;

      // No search → include directly
      if (!search) {
        acc.push(idx);
        return acc;
      }

      // Basic search on value (NO splitting!)
      if (item.value.toLowerCase().includes(search)) {
        acc.push(idx);
      }

      return acc;
    }, []);
  }, [transformedStrings, activeFilter, searchStringValue]);

  // const errorIndexes = useMemo(() => {
  //   if (!transformedStrings) return [];

  //   return transformedStrings.reduce((acc, item, idx) => {
  //     if (item.type === "error" || item.type === "warning" || item.type === "review_error") {
  //       acc.push(idx);
  //     }
  //     return acc;
  //   }, []);
  // }, [transformedStrings]);

  const goToNextError = () => {
    if (activeFilter !== "all") return;
    track("tech_qc_ms_next_error");

    const list = visibleErrorGlobalIndexes;
    if (!list || list.length === 0) {
      toast.error("No errors/warnings available");
      return;
    }

    // if (currentErrorGlobalIndex === -1) {
    //   const first = list[0];
    //   setCurrentErrorGlobalIndex(first);
    //   // eslint-disable-next-line no-unused-expressions
    //   // listRef.current?.scrollToRow(first);
    //   return;
    // }

    const currentIndexPos = list.indexOf(currentErrorGlobalIndex);
    const nextPos = (currentIndexPos + 1) % list.length;
    const nextGlobalIndex = list[nextPos];

    setCurrentErrorGlobalIndex(nextGlobalIndex);
    // eslint-disable-next-line no-unused-expressions
    // listRef.current?.scrollToRow(nextGlobalIndex);
  };

  const goToPrevError = () => {
    if (activeFilter !== "all") return;
    track("tech_qc_ms_prev_error");

    const list = visibleErrorGlobalIndexes;
    if (!list || list.length === 0) {
      toast.error("No errors/warnings available");
      return;
    }

    // if (currentErrorGlobalIndex === -1) {
    //   const last = list[list.length - 1];
    //   setCurrentErrorGlobalIndex(last);
    //   // eslint-disable-next-line no-unused-expressions
    //   // listRef.current?.scrollToRow(last);
    //   return;
    // }

    const currentIndexPos = list.indexOf(currentErrorGlobalIndex);
    const prevPos = (currentIndexPos - 1 + list.length) % list.length;
    const prevGlobalIndex = list[prevPos];

    setCurrentErrorGlobalIndex(prevGlobalIndex);
    // eslint-disable-next-line no-unused-expressions
    // listRef.current?.scrollToRow(prevGlobalIndex);
  };

  // const filteredData = useMemo(() => {
  //   if (!transformedStrings) return [];

  //   const search = (searchStringValue || "").trim().toLowerCase();

  //   return transformedStrings.filter((item) => {
  //     if (activeFilter !== "all" && item.type !== activeFilter) {
  //       return false;
  //     }

  //     if (!search) {
  //       return true;
  //     }

  //     const parts = item.value?.split("-") || [];
  //     const timestamp = (parts[6] || "").toLowerCase();

  //     return (
  //       timestamp.includes(search) || item.value.toLowerCase().includes(search)
  //     );
  //   });
  // }, [transformedStrings, activeFilter, searchStringValue]);

  const filteredData = useMemo(() => {
    if (!transformedStrings) return [];

    return transformedStrings.filter((item) => {
      if (activeFilter !== "all" && item.type !== activeFilter) {
        return false;
      }
      return true;
    });
  }, [transformedStrings, activeFilter]);

  const lineNumberMap = useMemo(() => {
    if (!transformedStrings) return new Map();
    const map = new Map();
    transformedStrings.forEach((item, idx) => map.set(item.id ?? item.value, idx + 1));
    return map;
  }, [transformedStrings]);

  useEffect(() => {
    setCurrentSearchIndex(-1);
    setSearchMatchIndexes([]);
  }, [activeFilter]);

  useEffect(() => {
    if (!searchStringValue || !filteredData?.length) {
      setSearchMatchIndexes([]);
      setCurrentSearchIndex(-1);
      return;
    }

    const search = searchStringValue.toLowerCase();

    const matches = filteredData.reduce((acc, item, index) => {
      const parts = item.value?.split("-") || [];
      const timestamp = (parts[6] || "").toLowerCase();

      if (
        item.value.toLowerCase().includes(search) ||
        timestamp.includes(search)
      ) {
        acc.push(index); // ✅ index in filteredData
      }

      return acc;
    }, []);

    setSearchMatchIndexes(matches);
    setCurrentSearchIndex(matches.length ? matches[0] : -1);
  }, [searchStringValue, filteredData]);

  // Track searches once the user pauses typing (debounced), not per keystroke.
  useEffect(() => {
    const q = (searchStringValue || "").trim();
    if (!q) return;
    const t = setTimeout(() => {
      track("tech_qc_ms_search", { query: q, matches: searchMatchIndexes.length });
    }, 800);
    return () => clearTimeout(t);
  }, [searchStringValue, searchMatchIndexes.length, track]);

  const goToNextSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    track("tech_qc_ms_search_next");

    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const nextPos = (currentPos + 1) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[nextPos]);
  };

  const goToPrevSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    track("tech_qc_ms_search_prev");

    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const prevPos =
      (currentPos - 1 + searchMatchIndexes.length) % searchMatchIndexes.length;

    setCurrentSearchIndex(searchMatchIndexes[prevPos]);
  };

  if (isLoading) {
    return (
      <Stack
        style={{
          width: "100%",
          height: "100%",
          zIndex: 10,
          backgroundColor: "var(--surface-1)",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
        <Typography style={{ color: "var(--text-1)", fontFamily: "Source Sans 3" }}>
          loading setup...
        </Typography>
      </Stack>
    );
  }

  return (
    <div style={{ backgroundColor: isDarkMode ? "#0f1115" : "#f5f6f8", minHeight: "100vh" }}>
      {/* QC Result Modal */}
      {qcResultModal && (
        <div
          onClick={() => setQcResultModal(null)}
          style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ backgroundColor: "var(--surface-1)", borderRadius: 16, boxShadow: "0 8px 32px rgba(0,0,0,0.22)", width: 380, padding: "28px 28px 22px", border: "1px solid var(--border-1)" }}
          >
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", backgroundColor: "#e8f5e9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <FaCheckCircle size={16} color="#2e7d32" />
                </div>
                <span style={{ fontWeight: "700", fontSize: 16, color: "var(--text-1)" }}>Tech QC Complete</span>
              </div>
              <button onClick={() => setQcResultModal(null)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-2)", fontSize: 18, lineHeight: 1, padding: "2px 6px" }}>✕</button>
            </div>
            {/* Rows */}
            {[
              { label: "QC Errors", value: qcResultModal.errorCount, bg: "#fdecea", color: "#d32f2f" },
              { label: "Review Errors", value: qcResultModal.reviewErrorCount, bg: "#fdecea", color: "#DA1414" },
              { label: "Warnings", value: qcResultModal.warningCount, bg: "#fff8e1", color: "#f57c00" },
              { label: "No Errors", value: qcResultModal.noErrorsCount, bg: "#e8f5e9", color: "#2e7d32" },
            ].map(({ label, value, bg, color }) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 0", borderBottom: "1px solid var(--border-1)" }}>
                <span style={{ fontSize: 15, color: "var(--text-1)", fontWeight: "500" }}>{label}</span>
                <span style={{ backgroundColor: bg, color, fontWeight: "700", fontSize: 14, padding: "3px 14px", borderRadius: 8, minWidth: 40, textAlign: "center", display: "inline-block" }}>{value}</span>
              </div>
            ))}
            {/* Total */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 14 }}>
              <span style={{ fontSize: 15, color: "var(--text-1)", fontWeight: "700" }}>Total events tag</span>
              <span style={{ backgroundColor: isDarkMode ? "#fff" : "#1a1a1a", color: isDarkMode ? "#1a1a1a" : "#fff", fontWeight: "700", fontSize: 14, padding: "4px 14px", borderRadius: 8, minWidth: 40, textAlign: "center", display: "inline-block" }}>{qcResultModal.total}</span>
            </div>
            {/* Close button */}
            <button
              onClick={() => setQcResultModal(null)}
              style={{ marginTop: 22, width: "100%", paddingTop: 14, paddingBottom: 14, backgroundColor: "#FF5A1F", color: "#fff", fontWeight: "700", fontSize: 15, border: "none", borderRadius: 10, cursor: "pointer" }}
            >
              Done
            </button>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, id: null, value: "" })}
        onConfirm={confirmDelete}
        title="Delete String"
        isDarkMode={isDarkMode}
        message={
          <>
            Are you sure you want to delete this string?{" "}
            <strong>"{deleteModal.value}"</strong>
          </>
        }
        type="delete"
      />

      {/* Update Confirmation Modal */}
      <ConfirmationModal
        open={updateModal.open}
        onClose={() =>
          setUpdateModal({ open: false, id: null, oldValue: "", newValue: {} })
        }
        onConfirm={confirmUpdate}
        title="Update String"
        isDarkMode={isDarkMode}
        message={
          <>
            Are you sure you want to update this string from{" "}
            <strong>"{updateModal.oldValue}"</strong> to{" "}
            <strong>"{updateModal.newValue?.value}"</strong>?
          </>
        }
        type="update"
      />
      {/* Header */}
      <div style={styles.header.container}>
        <div style={styles.header.side}>
          <IconButton
            onClick={() => {
              track("tech_qc_ms_back");
              history.goBack();
            }}
            size="small"
            sx={{
              background: isDarkMode ? "#000" : "#E5E7EB",
              color: isDarkMode ? "#fff" : "#111827",
              mr: 1,
              border: isDarkMode ? "1px solid #374151" : "1px solid #D1D5DB",
              "&:hover": { background: isDarkMode ? "#111827" : "#D1D5DB" },
            }}
          >
            <ArrowBack fontSize="16px" />
          </IconButton>
        </div>
        <div style={styles.header.center}>
          <span style={styles.header.score}>{matchId}</span>
          <span style={styles.header.matchInfo}>
            {matchDetails?.team_a_details?.name} vs{" "}
            {matchDetails?.team_b_details?.name}
          </span>
        </div>
        <div style={styles.header.side}>
          <IconButton
            aria-label="toggle theme"
            onClick={toggleMode}
            size="small"
            sx={{ color: "var(--text-2)", borderRadius: "8px", width: 36, height: 36, "&:hover": { backgroundColor: "var(--surface-2)" } }}
          >
            {themeMode === "dark" ? <LightModeOutlined sx={{ fontSize: 20 }} /> : <DarkModeOutlined sx={{ fontSize: 20 }} />}
          </IconButton>
        </div>
      </div>

      {/* Cards */}
      <div style={styles.cardContainer}>
        {/* Card 1 */}
        <div style={styles.card1.card}>
          <div style={styles.card1.content}>
            <div style={{ ...styles.card1.team, alignItems: "center" }}>
              <div style={styles.card1.label}>Team A</div>
              <div style={styles.card1.teamNameText}>
                {matchDetails?.team_a_details?.name}
              </div>
            </div>
            <div style={{ fontWeight: "700", fontSize: 12, color: "var(--text-2)", padding: "0 8px" }}>vs</div>
            <div style={{ ...styles.card1.team, alignItems: "center" }}>
              <div style={styles.card1.label}>Team B</div>
              <div style={styles.card1.teamNameText}>
                {matchDetails?.team_b_details?.name}
              </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div style={styles.card2.card}>
          <div style={styles.card2.content}>
            <div style={styles.card2.box}>
              <div style={styles.card2.id}>
                {matchDetails?.analyst_details?.[0]?.id}
              </div>
            </div>

            <div style={styles.card2.textRight}>
              <div style={styles.card2.name}>
                {matchDetails?.analyst_details?.[0]?.name}
              </div>
              <div style={styles.card2.label}>Analyst ID & Name</div>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div style={styles.card3.card}>
          <div style={styles.card3.row}>
            <div style={styles.card3.title}>Elapsed time</div>

            <div style={styles.card3.timeProgressWrapper}>
              <div style={styles.card3.time}>
                {formatTimeFromSeconds(details?.analysis_tat) || "00:00:00"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.urlCard.wrapper}>
        {showUrlInput ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <input
              type="text"
              autoFocus
              placeholder="Paste video URL..."
              value={urlInput}
              onChange={(e) => setUrlInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && urlInput.trim()) { props.LoadVideoUrl(urlInput.trim()); setShowUrlInput(false); } if (e.key === "Escape") setShowUrlInput(false); }}
              style={{ flex: 1, padding: "8px 12px", border: "1px solid var(--border-1)", borderRadius: 8, outline: "none", fontSize: 13, backgroundColor: "var(--surface-2)", color: "var(--text-1)" }}
            />
            <button onClick={() => { if (urlInput.trim()) { props.LoadVideoUrl(urlInput.trim()); setShowUrlInput(false); } }} style={{ backgroundColor: "#FF5A1F", border: "none", padding: "8px 16px", borderRadius: 8, color: "#fff", fontWeight: "600", fontSize: 13, cursor: "pointer" }}>Load</button>
            <button onClick={() => setShowUrlInput(false)} style={{ background: "none", border: "1px solid var(--border-1)", padding: "8px 12px", borderRadius: 8, color: "var(--text-2)", fontSize: 13, cursor: "pointer" }}>Cancel</button>
          </div>
        ) : (
          <div style={styles.urlCard.row}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1, minWidth: 0, overflow: "hidden" }}>
              <FaLink size={13} color="var(--text-2)" style={{ flexShrink: 0 }} />
              <span style={{ fontSize: 12, color: "var(--text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {props.videoUrl || matchDetails?.youtube_videos?.[0]?.url || "No video loaded"}
              </span>
            </div>
            <button onClick={() => setShowUrlInput(true)} style={{ background: "none", border: "1px solid var(--border-1)", padding: "5px 14px", borderRadius: 6, color: "var(--text-2)", fontSize: 12, cursor: "pointer", whiteSpace: "nowrap", fontWeight: "500" }}>Load URL</button>
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          margin: "1rem",
          backgroundColor: isDarkMode ? "#0f1115" : "#f5f6f8",
        }}
      >
        <div
          style={{
            width: "60%",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <View style={styles.videoContainer}>
              {props.videoUrl || matchDetails?.youtube_videos?.[0]?.url ? (
                <VideoPlayer
                  cref={playerRef}
                  url={props.videoUrl || matchDetails?.youtube_videos?.[0]?.url}
                  controls={showControls}
                  played={props.videoTime}
                  muted={isMute}
                  onProgress={(e) => {
                    !seeking && UpdateVideoTime(e);
                  }}
                  //    setElapsedTime={this.setElapsedTime}
                  playing={props.videoControl}
                  onPause={() => {
                    SetVideoControl(false);
                  }}
                  onEnded={() => {
                    SetVideoControl(false);
                  }}
                  onPlay={() => {
                    SetVideoControl(true);
                  }}
                  onReady={() => {
                    setReady(true);
                  }}
                  playbackRate={speed}
                  onDuration={(t) => {
                    setDuration(t);
                  }}
                />
              ) : (
                <Stack
                  style={{
                    height: "60vh",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ fontSize: 16, color: "#FF5A1F" }}>
                    Video URL Not Found.
                  </Typography>
                </Stack>
              )}

              {ready && !isYoutubeUrl() && (
                <View style={styles.videoTimeline}>
                  <input
                    type="range"
                    value={props.videoTime}
                    style={{ width: "100%", borderWidth: 0 }}
                    min={0}
                    max={duration * 1000}
                    step={10}
                    onMouseDown={handleSeekMouseDown}
                    onChange={(e) => handleSeekChange(e.target.value)}
                    onMouseUp={(e) => handleSeekMouseUp(e.target.value)}
                  />
                </View>
              )}

              {ready && (
                <View style={styles.controlContainer}>
                  {/* Left: Jump To + timestamp */}
                  <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 5 }}>
                    <FaStopwatch size={11} color="var(--text-2)" />
                    <TextInput
                      style={{
                        width: "5.5rem", fontSize: "11px",
                        border: "1px solid var(--border-1)", borderRadius: "5px",
                        backgroundColor: "var(--surface-2)", color: "var(--text-1)",
                        paddingVertical: "5px", paddingHorizontal: "6px",
                        outline: "none", textAlign: "center",
                      }}
                      onChangeText={setJumpTo}
                      defaultValue={jumpTo}
                      placeholder="HH:MM:SS"
                    />
                    <TouchableOpacity
                      disabled={jumpTo === ""}
                      onPress={() => jumpManually(jumpTo)}
                      style={{
                        width: 26, height: 26, borderRadius: 5,
                        justifyContent: "center", alignItems: "center",
                        backgroundColor: jumpTo ? "#FF5A1F" : "var(--surface-2)",
                        border: "1px solid var(--border-1)",
                      }}
                    >
                      <FaArrowRight size={9} color={jumpTo ? "#fff" : "var(--text-2)"} />
                    </TouchableOpacity>
                    {!isYoutubeUrl() && (
                      <>
                        <div style={{ width: 1, height: 18, background: "var(--border-1)", margin: "0 4px" }} />
                        <Duration milliseconds={props.videoTime} />
                      </>
                    )}
                  </div>

                  {/* Center: Play/Pause */}
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {!isYoutubeUrl() && (
                      <TouchableOpacity
                        onPress={() => {  track("tech_qc_ms_video_playpause", { playing: !props.videoControl, source: "button" });
                            props.SetVideoControl(!props.videoControl); }}
                        style={{
                          flexDirection: "row", alignItems: "center", gap: 6,
                          backgroundColor: "#FF5A1F",
                          paddingHorizontal: "14px", paddingVertical: "6px",
                          borderRadius: "7px",
                        }}
                      >
                        {!props.videoControl ? <FaPlay color="#fff" size={10} /> : <FaPause color="#fff" size={10} />}
                        <Text style={{ fontSize: "12px", color: "#fff", fontWeight: "600" }}>
                          {!props.videoControl ? "Play" : "Pause"}
                        </Text>
                      </TouchableOpacity>
                    )}
                  </div>

                  {/* Right: Speed pills + icons */}
                  <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                    {!isYoutubeUrl() && (
                      <div style={{ display: "flex", border: "1px solid var(--border-1)", borderRadius: 6, overflow: "hidden" }}>
                        {[0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75].map((s, i) => (
                          <TouchableOpacity
                            key={s}
                            onPress={() => setSpeed(s)}
                            style={{
                              paddingHorizontal: "8px", paddingVertical: "5px",
                              backgroundColor: speed === s ? "#FF5A1F" : "var(--surface-2)",
                              borderRight: i < 6 ? "1px solid var(--border-1)" : "none",
                              alignItems: "center", justifyContent: "center",
                            }}
                          >
                            <Text style={{ fontSize: "10px", fontWeight: "600", color: speed === s ? "#fff" : "var(--text-2)" }}>
                              {s}x
                            </Text>
                          </TouchableOpacity>
                        ))}
                      </div>
                    )}
                    <TouchableOpacity
                      onPress={full}
                      style={{ width: 28, height: 28, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      <AiOutlineFullscreen color="var(--text-1)" size={14} />
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={handleMute}
                      style={{ width: 28, height: 28, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      {isMute ? <IoMdVolumeOff color="var(--text-1)" size={14} /> : <IoMdVolumeHigh color="var(--text-1)" size={14} />}
                    </TouchableOpacity>
                  </div>
                </View>
              )}
            </View>
            <div style={{ marginTop: 10, display: "flex", borderRadius: 10, border: "1px solid var(--border-1)", flexDirection: "row", alignItems: "stretch", overflow: "hidden", backgroundColor: "var(--surface-1)" }}>
              {/* Event Details */}
              <div style={{ borderRight: "1px solid var(--border-1)", padding: "12px 14px", width: "33%" }}>
                <div style={{ fontSize: 11, fontWeight: "700", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-2)" }}>Event Details</div>
                <InfoRow label="QC Errors" value={initialEventDetails?.error || 0} bgColor="#fdecea" textColor="#d32f2f" />
                <InfoRow label="Review Errors" value={initialEventDetails?.reviewError || 0} bgColor="#fdecea" textColor="#DA1414" />
                <InfoRow label="Warnings" value={initialEventDetails?.warning || 0} bgColor="#fff4cc" textColor="#f57c00" />
                <InfoRow label="No Errors" value={initialEventDetails?.noIssue || 0} bgColor="#e6f4ea" textColor="#2e7d32" />
                <InfoRow label="Total events tag" value={initialEventDetails.total || 0} bgColor="#333" textColor="#fff" bold />
                <div style={{ marginTop: 6, fontSize: 11, color: "#E02424", lineHeight: "1.5" }}>Resolve all errors and warnings before submitting.</div>
              </div>

              {/* QC Status */}
              <div style={{ borderRight: "1px solid var(--border-1)", padding: "12px 14px", width: "33%" }}>
                <div style={{ fontSize: 11, fontWeight: "700", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-2)" }}>QC Status</div>
                <InfoRow label="Active Errors" value={errorCount || 0} bgColor="#fdecea" textColor="#d32f2f" />
                <InfoRow label="Active Review Errors" value={reviewErrorCount || 0} bgColor="#fdecea" textColor="#DA1414" />
                <InfoRow label="Active Warnings" value={warningCount || 0} bgColor="#fff4cc" textColor="#f57c00" />
                <InfoRow label="No Errors" value={noErrorsCount || 0} bgColor="#e6f4ea" textColor="#2e7d32" />
                <InfoRow label="Issues Fixed" value={Math.max((initialEventDetails.warning || 0) + (initialEventDetails.error || 0) + (initialEventDetails.reviewError || 0) - (errorCount + warningCount + reviewErrorCount), 0) || 0} bgColor="#e3f2fd" textColor="#1976d2" />
                <InfoRow label="Total events tag" value={transformedStrings?.length || 0} bgColor="#333" textColor="#fff" bold />
              </div>

              {/* Actions */}
              <div style={{ padding: "12px 14px", width: "33%", display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ fontSize: 11, fontWeight: "700", marginBottom: 0, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-2)" }}>Actions</div>
                <button
                  style={{ backgroundColor: "#FF5A1F", paddingTop: 18, paddingBottom: 18, paddingLeft: 0, paddingRight: 0, borderRadius: 8, border: "none", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", opacity: transformedStrings?.length === undefined || isRunningQC ? 0.5 : 1, cursor: transformedStrings?.length === undefined || isRunningQC ? "not-allowed" : "pointer" }}
                  disabled={transformedStrings?.length === undefined || isRunningQC}
                  onClick={runTechQCManually}
                >
                  <span style={{ color: "#fff", fontWeight: "700", fontSize: 15, display: "flex", alignItems: "center", gap: 7 }}>
                    {isRunningQC ? <CircularProgress size={16} thickness={4} color="inherit" sx={{ color: "#fff" }} /> : <><FaSyncAlt size={14} /> Run Tech QC</>}
                  </span>
                </button>
                <button
                  style={{ backgroundColor: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 ? "var(--surface-2)" : "#007D48", paddingTop: 18, paddingBottom: 18, paddingLeft: 0, paddingRight: 0, borderRadius: 8, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", border: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 ? "1px solid var(--border-1)" : "none", opacity: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined ? 0.5 : 1, cursor: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined ? "not-allowed" : "pointer" }}
                  disabled={isSubmitting || errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined}
                  onClick={handleSubmitFinalQC}
                >
                  <span style={{ color: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 ? "var(--text-2)" : "#fff", fontWeight: "700", fontSize: 15, display: "flex", alignItems: "center", gap: 7 }}>
                    {isSubmitting ? <CircularProgress size={16} thickness={4} sx={{ color: "#fff" }} /> : <>Mark Analysis Done <FaArrowRight size={13} /></>}
                  </span>
                </button>
                {errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined ? (
                  <div style={{ fontSize: 11, color: "#E02424", lineHeight: "1.5" }}>Resolve all errors and warnings before submitting.</div>
                ) : (
                  <div style={{ fontSize: 11, color: "#2e7d32" }}>✓ All issues addressed. Ready to submit.</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            flex: "0 0 42%",
            overflow: "hidden",
            borderRadius: 10,
            backgroundColor: "var(--surface-1)",
            color: "var(--text-1)",
            border: "1px solid var(--border-1)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "1rem 1rem 0rem 1rem",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <FilterButtons
                active={activeFilter}
                setActive={(v) => { track("tech_qc_ms_filter", { filter: v }); setActiveFilter(v); }}
              />
              <div style={{ display: "flex", gap: 6, flexShrink: 0, marginLeft: 8 }}>
                <button
                  title="Go to Top"
                  onClick={() => listRef.current?.scrollToPosition(0)}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 12px", borderRadius: 8, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", color: "var(--text-2)", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  <FaArrowLeft style={{ transform: "rotate(90deg)" }} size={10} /> Top
                </button>
                <button
                  title="Go to Bottom"
                  onClick={() => listRef.current?.scrollToRow(filteredData.length - 1)}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 12px", borderRadius: 8, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", color: "var(--text-2)", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  <FaArrowLeft style={{ transform: "rotate(270deg)" }} size={10} /> Bottom
                </button>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                margin: "10px",
                alignItems: "center",
              }}
            >
              {/* Search Box */}
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "var(--surface-2)",
                  borderRadius: 6,
                  padding: "8px 12px",
                  border: "1px solid var(--border-1)",
                }}
              >
                <FaSearch color="var(--text-2)" size={14} />
                <input
                  value={searchStringValue}
                  onChange={(e) => setSearchStringValue(e.target.value)}
                  placeholder="Search String by Timestamp"
                  style={{
                    flex: 1,
                    marginLeft: 8,
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    fontSize: 13,
                    color: "var(--text-1)",
                  }}
                />
                {searchStringValue && searchMatchIndexes.length > 0 && (
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        paddingRight: "6px",
                        borderRight: "1px solid var(--border-1)",
                        color: "var(--text-2)",
                      }}
                    >
                      {searchMatchIndexes.indexOf(currentSearchIndex) + 1} /{" "}
                      {searchMatchIndexes.length}
                    </Typography>

                    <FaAngleUp
                      onClick={goToNextSearchMatch}
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                    />

                    <FaAngleDown
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                      onClick={goToPrevSearchMatch}
                    />
                    <FaTimes
                      size={16}
                      color="#6B7280"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSearchStringValue("")}
                    />
                  </Stack>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  gap: 10,
                }}
              >
                {/* Prev Error Button */}
                <button
                  disabled={Boolean(searchStringValue.length)}
                  onClick={goToPrevError}
                  style={{
                    flex: 1,
                    cursor: Boolean(searchStringValue.length) ? "not-allowed" : "pointer",
                    opacity: Boolean(searchStringValue.length) ? 0.5 : 1,
                    paddingTop: 11, paddingBottom: 11,
                    borderRadius: 8,
                    backgroundColor: "var(--surface-1)",
                    border: "1px solid var(--border-1)",
                    fontWeight: 600,
                    fontSize: 13,
                    color: "var(--text-1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 7,
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaArrowLeft size={11} /> Prev Error
                </button>

                {/* Next Error Button */}
                <button
                  disabled={Boolean(searchStringValue.length)}
                  onClick={goToNextError}
                  style={{
                    flex: 1,
                    cursor: Boolean(searchStringValue.length) ? "not-allowed" : "pointer",
                    opacity: Boolean(searchStringValue.length) ? 0.5 : 1,
                    paddingTop: 11, paddingBottom: 11,
                    borderRadius: 8,
                    backgroundColor: "#FF5A1F",
                    color: "#fff",
                    border: "none",
                    fontWeight: 600,
                    fontSize: 13,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 7,
                    whiteSpace: "nowrap",
                  }}
                >
                  Next Error <FaArrowRight size={11} />
                </button>

                <LegendTooltipIcon />
              </div>
            </div>
          </div>
          {transformedStrings && transformedStrings.length > 0 ? (
            <div style={{ height: "87%", backgroundColor: "var(--surface-1)" }}>
              {filteredData.length > 0 ? (
                <AutoSizer>
                  {({ width, height }) => {
                    return (
                      <List
                        ref={listRef}
                        scrollToAlignment="start"
                        style={{
                          padding: "10px",
                          marginTop: "0.6rem",
                          paddingBottom: "2rem",
                          backgroundColor: "var(--surface-1)",
                        }}
                        onScroll={({ scrollTop }) => {
                          setScrollPosition(scrollTop);
                        }}
                        width={width}
                        height={height}
                        deferredMeasurementCache={cache.current}
                        rowCount={filteredData.length}
                        scrollToIndex={
                          searchStringValue && currentSearchIndex !== -1
                            ? currentSearchIndex
                            : currentErrorGlobalIndex != null &&
                              !skipScrollToIndex
                              ? currentErrorGlobalIndex
                              : undefined
                        }
                        rowHeight={cache.current.rowHeight}
                        rowRenderer={({ index, key, style, parent }) => {
                          const item = filteredData[index];
                          return (
                            <CellMeasurer
                              key={key}
                              cache={cache.current}
                              parent={parent}
                              columnIndex={0}
                              rowIndex={index}
                            >
                              <div style={style}>
                                <EditableTag
                                  key={item.id}
                                  activeFilter={activeFilter}
                                  index={index}
                                  lineNumber={lineNumberMap.get(item.id ?? item.value)}
                                  refetch={refetchReviewerStrings}
                                  track={track}
                                  analystId={analystId}
                                  searchValue={searchStringValue}
                                  token={token}
                                  matchId={matchId}
                                  errorIndex={currentErrorGlobalIndex}
                                  reviewerId={reviewerId}
                                  text={item.value}
                                  type={item.type}
                                  message={item.message}
                                  ignored={item.ignored}
                                  reviewStatus={item.reviewStatus}
                                  reviewComments={item.reviewComments}
                                  reviewEntries={item.reviewEntries}
                                  onChange={(newVal) => {
                                    // cache.current.clear(index);
                                    updateTag(item.id, newVal);
                                  }}
                                  onAddNewtag={() => {
                                    // cache.current.clearAll();
                                    addTag(item.id);
                                  }}
                                  onDelete={() => {
                                    // cache.current.clearAll();
                                    deleteStringByIndex(item.id);
                                  }}
                                  jumpManually={jumpManually}
                                  isDarkMode={isDarkMode}
                                />
                              </div>
                            </CellMeasurer>
                          );
                        }}
                      />
                    );
                  }}
                </AutoSizer>
              ) : (
                <Stack
                  style={{
                    padding: 16,
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Typography style={{ color: "gray", fontSize: 16 }}>
                    {`No ${activeFilter} strings found`}
                  </Typography>
                </Stack>
              )}
            </div>
          ) : IsInitialQC ? (
            <Stack
              style={{
                flex: 1,
                padding: 16,
                alignItems: "center",
                justifyContent: "center",
                height: "60vh",
              }}
            >
              <Stack style={{ alignItems: "center" }}>
                <CircularProgress
                  sx={{
                    color: "#F96302",
                  }}
                />
                <Typography
                  style={{ color: "gray", fontSize: 16, marginTop: 12 }}
                >
                  Loading QC Data
                </Typography>
              </Stack>
            </Stack>
          ) : (
            <Stack
              style={{
                padding: 16,
                alignItems: "center",
                justifyContent: "center",
                maxHeight: "-webkit-fill-available",
                height: "60vh",
              }}
            >
              <Typography style={{ color: "gray", fontSize: 16 }}>
                No strings available
              </Typography>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, bgColor, textColor, bold }) => {
  const isDark = document.body.classList.contains("theme-dark");
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "5px 0",
      borderBottom: "1px solid var(--border-1)",
    }}>
      <span style={{ fontSize: 13, color: "var(--text-1)", fontWeight: bold ? "700" : "400" }}>
        {label}
      </span>
      <span style={{
        backgroundColor: isDark ? "transparent" : bgColor,
        padding: "2px 8px",
        borderRadius: 5,
        border: `1px solid ${isDark ? "var(--border-1)" : bgColor}`,
        color: textColor,
        fontWeight: "700",
        fontSize: 12,
        minWidth: 32,
        textAlign: "center",
        display: "inline-block",
      }}>
        {value}
      </span>
    </div>
  );
};

const EditableTag = ({
  text,
  activeFilter,
  ignored,
  onChange,
  errorIndex,
  index,
  lineNumber,
  refetch,
  message,
  onAddNewtag,
  onDelete,
  type = "noIssue",
  analystId,
  jumpManually,
  token,
  matchId,
  searchValue,
  reviewerId,
  reviewStatus,
  reviewComments,
  reviewEntries,
  isDarkMode,
  track = () => {},
}) => {
  const reviewItem = { reviewEntries, reviewStatus, reviewComments };
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);

  const highlightText = (text, search) => {
    if (!search) return text;
    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escaped})`, "ig");
    return text.split(regex).map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#FFE58F",
            padding: "0 2px",
            borderRadius: 3,
            fontWeight: 600,
          }}
        >
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      )
    );
  };

  const getEventFromString = (str) => {
    const parts = str?.split("-");
    if (parts?.length < 3) return null;
    const eventCode = `${parts?.[2]}-${parts?.[3]}`;
    return EVENT_MAP[eventCode] || null;
  };

  useEffect(() => {
    setValue(text);
  }, [text]);

  const handleIgnoredStrings = async () => {
    track("tech_qc_ms_mark_ignored", { string: value });
    try {
      await Promise.all(
        reviewRowsFor(reviewItem, reviewerId).map((row) =>
          saveReviewerFeedback({
            token,
            body: {
              match_id: Number(matchId),
              reviewer_id: row.reviewer_id,
              string_details: [
                {
                  string: value,
                  string_status: 3,
                  comments: message || "",
                },
              ],
            },
          })
        )
      );
      toast.success("Marked as Ignored");
      onChange({
        value,
        type: "ignored",
        message,
        ignored: true,
        reviewStatus: 3,
        reviewComments: message,
      });
    } catch (err) {
      console.error("Failed to ignore string:", err);
      toast.error("Failed to mark as ignored");
    }
  };

  const handleMarkedAsFixed = async () => {
    track("tech_qc_ms_mark_fixed", { string: value });
    try {
      await Promise.all(
        reviewRowsFor(reviewItem, reviewerId).map((row) =>
          saveReviewerFeedback({
            token,
            body: {
              match_id: Number(matchId),
              reviewer_id: row.reviewer_id,
              string_details: [
                {
                  string: value,
                  string_status: 1,
                  comments: row.comments,
                },
              ],
            },
          })
        )
      );
      await refetch();
      toast.success("Marked as fixed");
      onChange({
        value,
        type: "fixed",
        message: "Issue resolved",
        ignored: false,
        reviewStatus: 1,
        reviewComments,
      });
    } catch (err) {
      console.error("Failed to fix review error:", err);
      toast.error("Failed to mark as fixed");
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    onChange({
      value,
      type,
      message,
      ignored,
      reviewStatus,
      reviewComments,
    });
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return {
          text: "Pending",
          color: isDarkMode ? "#ffb74d" : "#f57c00",
          bgColor: isDarkMode ? "#332b00" : "#fff4cc"
        };
      case 1:
        return {
          text: "Approved",
          color: isDarkMode ? "#81c784" : "#2e7d32",
          bgColor: isDarkMode ? "#132f15" : "#e6f4ea"
        };
      case 2:
        return {
          text: "Rejected",
          color: isDarkMode ? "#e57373" : "#d32f2f",
          bgColor: isDarkMode ? "#3e1a1a" : "#fdecea"
        };
      default:
        return {
          text: "N/A",
          color: isDarkMode ? "#bbb" : "#666",
          bgColor: isDarkMode ? "#333" : "#f5f5f5"
        };
    }
  };

  const getStyleByType = (type, stringValue) => {
    const eventData = getEventFromString(stringValue);
    const adjustBg = (color) => isDarkMode ? `${color}40` : color;
    const adjustText = (color) => isDarkMode ? "#ffffff" : "#000000";

    switch (type) {
      case "error":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
          textColor: isDarkMode ? "#ff8a8a" : "#DA1414",
          iconColor: "#DA1414",
          badgeColor: isDarkMode ? "#451010" : "#f6e3e3ff",
          status: "Error",
        };
      case "review_error":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
          textColor: isDarkMode ? "#ff8a8a" : "#DA1414",
          iconColor: "#DA1414",
          badgeColor: isDarkMode ? "#451010" : "#f6e3e3ff",
          status: "Review Error",
        };
      case "warning":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#B95000",
          backgroundColor: isDarkMode ? "#452a10" : "#FFF4EC",
          textColor: isDarkMode ? "#ffb37a" : "#B95000",
          badgeColor: isDarkMode ? "#452a10" : "#f7e9ddff",
          iconColor: "#B95000",
          status: "Warning",
        };
      case "fixed":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          badgeColor: isDarkMode ? "#102a45" : "#bad9faff",
          status: "Fixed",
          borderColor: "#1A56DB",
          backgroundColor: isDarkMode ? "#102a45" : "#E1EFFE",
          textColor: adjustText("#1A56DB"),
          iconColor: "#1A56DB",
        };
      case "ignored":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: isDarkMode ? "#10451d" : "#EDF9F0",
          textColor: isDarkMode ? "#8ae59e" : "#287D3C",
          iconColor: "#287D3C",
          badgeColor: isDarkMode ? "#10451d" : "#d9f2ddff",
          status: "Ignored",
        };
      case "noIssue":
      default:
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: isDarkMode ? "#10451d" : "#EDF9F0",
          textColor: isDarkMode ? "#8ae59e" : "#287D3C",
          iconColor: "#287D3C",
          badgeColor: isDarkMode ? "#10451d" : "#d9f2ddff",
          status: "No issue",
        };
    }
  };

  const {
    borderColor,
    statusIcon,
    backgroundColor,
    badgeColor,
    textColor,
    iconColor,
    status,
  } = getStyleByType(type, value);

  const reduceTimeBySeconds = (timeString, secondsToReduce) => {
    const [hh, mm, rest] = timeString.split(":");
    const [ss, ms = "0"] = rest.split(".");
    const hours = parseInt(hh, 10);
    const minutes = parseInt(mm, 10);
    const seconds = parseInt(ss, 10);
    const milliseconds = parseInt(ms.padEnd(3, "0"), 10);
    let totalMs = (hours * 3600 + minutes * 60 + seconds) * 1000 + milliseconds;
    totalMs -= secondsToReduce * 1000;
    if (totalMs < 0) totalMs = 0;
    const newHours = Math.floor(totalMs / 3600000);
    const newMinutes = Math.floor((totalMs % 3600000) / 60000);
    const newSeconds = Math.floor((totalMs % 60000) / 1000);
    const newMs = totalMs % 1000;
    return `${newHours.toString().padStart(2, "0")}:${newMinutes.toString().padStart(2, "0")}:${newSeconds.toString().padStart(2, "0")}.${newMs.toString().padStart(3, "0")}`;
  };

  const jumpManuallyViaString = () => {
    const timeStr = value.split("-")[6];
    const newTimeStr = reduceTimeBySeconds(timeStr, 2);
    jumpManually(newTimeStr);
  };

  // const statusInfo = getStatusLabel(reviewStatus);

  return (
    <Stack>
      <Stack sx={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", width: "100%", marginBottom: "5px", justifyContent: "center" }}>
        {lineNumber != null && (
          <span style={{ fontSize: 10, color: "var(--text-2)", fontWeight: "600", minWidth: 28, textAlign: "right", flexShrink: 0, userSelect: "none", letterSpacing: "0.02em" }}>
            {lineNumber}
          </span>
        )}
        <Stack sx={{ backgroundColor, borderRadius: "8px", paddingX: "12px", paddingY: "10px", border: `1px solid ${borderColor}`, minHeight: "30px", width: lineNumber != null ? "calc(90% - 33px)" : "90%", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
          <TouchableOpacity activeOpacity={1} style={{ flex: 1 }}>
            {isEditing ? (
              <TextInput
                autoFocus
                value={value}
                onChangeText={setValue}
                onBlur={handleBlur}
                style={{
                  fontSize: 14,
                  color: isDarkMode ? "white" : "black",
                  backgroundColor: isDarkMode ? "var(--surface-2)" : "#fff",
                  outline: "none",
                  padding: 3,
                  borderRadius: 4,
                }}
              />
            ) : (
              <Typography style={{ fontSize: 14, color: textColor, display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem" }}>
                {React.createElement(statusIcon, { color: iconColor })}
                <span>{highlightText(value, searchValue)}</span>
              </Typography>
            )}
          </TouchableOpacity>
          <Stack style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
            {isEditing && (
              <TouchableOpacity onPress={handleBlur} style={{ marginLeft: "1rem" }}>
                <FaCheck color={iconColor} />
              </TouchableOpacity>
            )}
            <TouchableOpacity onPress={jumpManuallyViaString}>
              <FaVideo color={iconColor} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => setIsEditing(true)}>
              <FaEdit color={iconColor} />
            </TouchableOpacity>
            <TouchableOpacity onPress={onDelete}>
              <FaTrashAlt color="#DA1414" />
            </TouchableOpacity>
            {type === "warning" ? (
              <TouchableOpacity style={{ paddingHorizontal: 8, paddingVertical: 4, borderRadius: 4, borderWidth: 1, borderColor: iconColor, marginLeft: 6 }} onPress={handleIgnoredStrings}>
                <Typography style={{ color: iconColor, fontSize: 12 }}>Mark as Ignored</Typography>
              </TouchableOpacity>
            ) : type === "review_error" ? (
              <TouchableOpacity style={{ paddingHorizontal: 8, paddingVertical: 4, borderRadius: 4, borderWidth: 1, backgroundColor: badgeColor, borderColor: borderColor, marginLeft: 6 }} onPress={handleMarkedAsFixed}>
                <Typography style={{ color: textColor, fontSize: 12 }}>Mark as Fixed</Typography>
              </TouchableOpacity>
            ) : (
              <Typography style={{ color: iconColor, borderRadius: "5px", marginLeft: 8, backgroundColor: badgeColor, padding: "0.2rem", fontSize: 12 }}>{status}</Typography>
            )}
          </Stack>
        </Stack>
        {activeFilter === "all" && (
          <TouchableOpacity style={{ color: "white", backgroundColor: "#FF5A1F", borderRadius: "8px", padding: "12px" }} onPress={() => onAddNewtag(index)}>
            <FaPlus />
          </TouchableOpacity>
        )}
      </Stack>
      {(type === "warning" || type === "error" || type === "review_error") && message ? (
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          {lineNumber != null && <div style={{ minWidth: 33, flexShrink: 0 }} />}
          <Typography
            style={{
              padding: "6px 10px",
              width: lineNumber != null ? "calc(90% - 33px)" : "90%",
              marginBottom: 4,
              fontSize: 12,
              borderRadius: "8px",
              ...(type === "warning" ? {
                backgroundColor: isDarkMode ? "#452a10" : "#FFF4EC",
                color: isDarkMode ? "#ffb37a" : "#B95000",
              } : type === "review_error" ? {
                border: isDarkMode ? "1px solid #374151" : "1px solid #DA1414",
                backgroundColor: isDarkMode ? "#000" : "#fdecea",
                color: isDarkMode ? "#fff" : "#DA1414",
              } : {
                backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
                color: isDarkMode ? "#ff8a8a" : "#DA1414",
              }),
            }}
          >
            {type === "warning" ? "Warning! " : type === "review_error" ? "Review Error! " : "Error! "}{message}
          </Typography>
        </div>
      ) : null}
    </Stack>
  );
};

const FilterButtons = ({ active, setActive }) => {
  const filters = [
    { label: "All", value: "all" },
    { label: "Errors", value: "error" },
    { label: "Review Errors", value: "review_error" },
    { label: "Warnings", value: "warning" },
    { label: "Ignored", value: "ignored" },
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        marginTop: 8,
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: 8,
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {filters.map(({ label, value }) => {
        const isActive = active === value;

        return (
          <button
            key={value}
            type="button"
            onClick={() => setActive(value)}
            style={{
              backgroundColor: isActive ? "#FF5A1F" : "var(--surface-2)",
              borderRadius: 6,
              flex: "0 0 auto",
              padding: "0 10px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: isActive ? "none" : "1px solid var(--border-1)",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                color: isActive ? "#fff" : "var(--text-1)",
                fontSize: 12,
                fontWeight: "500",
              }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const LegendTooltipIcon = () => {
  const grouped = {
    passing: [],
    shooting: [],
    defending: [],
    goalkeeping: [],
  };

  Object.entries(EVENT_MAP).forEach(([key, val]) => {
    grouped[val.group].push({ code: key, ...val });
  });

  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            p: 1,
          }}
        >
          {/* PASSING */}
          <GroupLabel title="Passing (Green tones)" />
          {grouped.passing.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* SHOOTING */}
          <GroupLabel title="Shooting (Red / Orange tones)" mt />

          {grouped.shooting.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* DEFENDING */}
          <GroupLabel title="Defending (Blue tones)" mt />

          {grouped.defending.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* GK */}
          <GroupLabel title="Goalkeeping (Purple / Amber)" mt />

          {grouped.goalkeeping.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            background: "var(--surface-1)",
            border: "1px solid var(--border-1)",
            borderRadius: "8px",
            maxWidth: 260,
            p: 1,
            color: "var(--text-1)",
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          },
        },
        arrow: {
          sx: { color: "var(--surface-1)" },
        },
      }}
    >
      <IconButton
        size="small"
        sx={{
          color: "var(--text-2)",
          border: "1px solid var(--border-1)",
          borderRadius: "50%",
          width: 26,
          height: 26,
          "&:hover": { backgroundColor: "var(--surface-2)", color: "var(--text-1)" },
        }}
      >
        <InfoOutlined sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
};

const GroupLabel = ({ title, mt }) => (
  <Typography
    fontWeight={700}
    fontSize={12}
    sx={{ mt: mt ? 1 : 0.2, mb: 0.5, color: "var(--text-1)" }}
  >
    {title}
  </Typography>
);

const LegendRow = ({ item }) => (
  <Stack direction="row" alignItems="center" spacing={1} mb={0.4}>
    <Box sx={{ width: 12, height: 12, borderRadius: "3px", background: item.color, flexShrink: 0 }} />
    <Typography sx={{ width: 48, fontSize: 12, fontWeight: 600, color: "var(--text-1)" }}>
      {item.code}
    </Typography>
    <Typography sx={{ fontSize: 12, color: "var(--text-2)" }}>{item.label}</Typography>
  </Stack>
);

const styles = {
  header: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: 60,
      backgroundColor: "var(--surface-1)",
      padding: "0 16px",
      borderBottom: "1px solid var(--border-1)",
      zIndex: 10,
    },
    side: {
      width: 60,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
    },
    score: {
      color: "#1C64F2",
      fontWeight: "bold",
      fontSize: 16,
    },
    matchInfo: {
      color: "var(--text-1)",
      fontSize: 14,
    },
    logout: {
      color: "#FF5A1F",
      cursor: "pointer",
      fontWeight: "500",
    },
  },

  cardContainer: {
    display: "flex",
    gap: 10,
    padding: "12px 20px",
  },

  card1: {
    card: {
      flex: 1,
      borderRadius: 12,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      padding: "14px 18px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      display: "flex",
      width: "100%",
      justifyContent: "space-around",
      alignItems: "center",
    },
    team: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      alignItems: "center",
      flex: 1,
    },
    teamNameText: {
      fontWeight: "700",
      fontSize: 15,
      textAlign: "center",
      color: "var(--text-1)",
    },
    teamBoxA: { display: "flex" },
    teamBoxB: { display: "flex" },
    label: {
      fontWeight: 400,
      textAlign: "center",
      fontSize: 11,
      color: "var(--text-2)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
    },
  },

  card2: {
    card: {
      flex: 1,
      borderRadius: 12,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      padding: "14px 18px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 14,
    },
    box: {
      backgroundColor: "rgba(12, 157, 65, 0.12)",
      width: 40,
      height: 40,
      borderRadius: 10,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
    },
    id: {
      fontWeight: "700",
      fontSize: 16,
      color: "rgba(12, 157, 65, 1)",
    },
    textRight: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
    },
    name: {
      fontWeight: "700",
      color: "var(--text-1)",
      fontSize: 15,
    },
    label: {
      fontSize: 11,
      color: "var(--text-2)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
    },
  },

  card3: {
    card: {
      flex: 1,
      borderRadius: 12,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      padding: "14px 18px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
    title: {
      fontWeight: 500,
      color: "var(--text-2)",
      fontSize: 13,
      textTransform: "uppercase",
      letterSpacing: "0.05em",
    },
    time: {
      color: "#FF5A1F",
      fontWeight: "700",
      fontSize: 18,
      fontVariantNumeric: "tabular-nums",
    },
    progressBar: { width: 60 },
    timeProgressWrapper: { display: "flex", alignItems: "center", gap: 20 },
  },

  urlCard: {
    wrapper: {
      padding: "8px 16px",
      borderRadius: 10,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      margin: "0 20px",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 12,
    },
  },

  container: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "var(--surface-1)",
    marginBottom: "1rem",
  },
  videoContainer: {
    width: "100%",
    borderRadius: 10,
    overflow: "hidden",
    border: "1px solid var(--border-1)",
    backgroundColor: "var(--surface-1)",
  },

  videoTimeline: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingHorizontal: "8px",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "var(--surface-2)",
    borderTop: "1px solid var(--border-1)",
  },

  controlContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: "var(--surface-1)",
    borderTop: "1px solid var(--border-1)",
    paddingHorizontal: "12px",
    paddingVertical: "8px",
  },
};

const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SetControllerToggle,
  ClearSeekFlag,
})(TechQCMS);
